import axios, { AxiosResponse } from 'axios';

import { UsuarioFuncionario } from '../type/UsuarioFuncionario';

const API_URL = '/painel-api/api/usuario-funcionario';

export const save = (
  funcionario: UsuarioFuncionario
): Promise<AxiosResponse<UsuarioFuncionario>> => {
  return funcionario.id
    ? axios.put(`${API_URL}/${funcionario.id}`, funcionario)
    : axios.post(API_URL, funcionario);
};

export const remove = (id: string): Promise<AxiosResponse<void>> => {
  return axios.delete(`${API_URL}/${id}`);
};

export const findAll = (
  cpf: string
): Promise<AxiosResponse<UsuarioFuncionario[]>> => {
  return axios.get<UsuarioFuncionario[]>(`${API_URL}/${cpf}/funcionarios`);
};

export const findById = (
  id: string
): Promise<AxiosResponse<UsuarioFuncionario>> => {
  return axios.get<UsuarioFuncionario>(`${API_URL}/${id}`);
};
